<template>
  <Notification :description="$t('rc_notification_cpa_eligible')" v-bind="$attrs">
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0 tw:shrink-0">
        <BaseLinkButton size="medium" class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap" @click="openModal">
          <span>{{ $t('rc_notifications_cta_change_campaigns') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import Notification from './Notification.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'
import { useRateConnect } from '@/components/rateConnect/useRateConnect'

defineProps({
  extraParameters: {
    type: [Object, null],
    required: true,
    default: null,
  },
})

const { openChangeCampaignModal } = useRateConnect()

const openModal = () => {
  openChangeCampaignModal()
}
</script>
